import React, { useState, useContext, useEffect } from "react";
import {
  Container,
  Segment,
  Form,
  Header,
  Icon,
  Button,
  Modal,
  Grid,
} from "semantic-ui-react";
import { RootStoreContext } from "../../app/stores/rootStore";
import { IUserFormValues } from "../../app/models/user";
import { Form as FinalForm, Field } from "react-final-form";
import TextInput from "../../app/common/form/TextInput";
import {
  combineValidators,
  composeValidators,
  isRequired,
  hasLengthGreaterThan,
  hasLengthLessThan,
} from "revalidate";
import SendEmailResetPassword from "./SendEmailResetPassword";
import { observer } from "mobx-react-lite";

const validate = combineValidators({
  username: composeValidators(
    isRequired({ message: "Usuario de acceso es obligatorio" }),
    hasLengthLessThan(129)({
      message: "El Usuario de acceso debe tener máximo 128 caracteres",
    })
  )(),
  password: composeValidators(
    isRequired({ message: "La contraseña es obligatoria" }),
    hasLengthGreaterThan(7)({
      message: "La contrseña debe tener al menos 8 caracteres",
    })
  )(),
});

const LoginForm = () => {
  //variables para el modal
  const [open, setOpen] = useState(false);
  const onClose = () => setOpen(false);
  const onOpen = () => setOpen(true);

  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { login, relogFromLogin, isLoggedIn } = rootStore.userStore;
  const { loading, changeState } = rootStore.buttonLoadingStore;

  useEffect(() => {
    if (!isLoggedIn) {
      relogFromLogin();
    }
  }, [isLoggedIn, relogFromLogin]);

  //variables para mostrar la contraseña
  const [shown, setShown] = useState(false);
  const switchShown = () => setShown(!shown);

  const [objAuthenticate] = useState<IUserFormValues>({
    username: "",
    password: "",
  });

  const handleFinalFormSubmit = (values: IUserFormValues) => {
    values.password = values.password.trim();
    changeState();
    login(values);
  };
  
  document.title = "Majim-e Marketplace - Login";

  return (
    <div className="centered">
      <Segment  clearing padded="very" className="loginDiv">
        <FinalForm
          validate={validate}
          initialValues={objAuthenticate}
          onSubmit={handleFinalFormSubmit}
          render={({ handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <Container textAlign="center">                
                <img src="./majimeLogo.png" width="300px"/>
                <br/>
                <br/>
              </Container>
              <Field
                name="username"
                placeholder="Usuario de acceso"
                value={objAuthenticate.username}
                component={TextInput}
              />
              <Container textAlign="right">
                <a
                  href="#pc"
                  className="password__button"
                  onClick={switchShown}
                >
                  {shown ? "Ocultar contraseña" : "Mostrar contraseña"}
                </a>
              </Container>
              <Field
                name="password"
                id="password"
                placeholder="Contraseña"
                type={shown ? "text" : "password"}
                value={objAuthenticate.password}
                component={TextInput}
              />
              <a href="#oc" onClick={onOpen}>
                Olvidé mi contraseña
              </a>
              <Container textAlign="center">
                <br />
                <Button
                  loading={loading}
                  disabled={loading}
                  className="ui primary button"
                  color="blue"
                  type="submit"
                  content="INGRESAR"
                />

                <br />
                <br />
                <p>Todos los derechos reservados.</p>
                <a href="#pp">
                  Politica de Privacidad <Icon name="external alternate" />
                </a>
              </Container>
            </Form>
          )}
        />
      </Segment>
      <Modal size="tiny" open={open} centered={false} onClose={onClose}>
        <Modal.Header>
          <Grid divided="vertically">
            <Grid.Row columns={2}>
              <Grid.Column>Recuperar contraseña</Grid.Column>
              <Grid.Column floated="right" width={2}>
                <a href="#" onClick={onClose}>
                  <Icon name="close" />
                </a>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Header>
        <Modal.Content>
          <SendEmailResetPassword />
        </Modal.Content>
      </Modal>
    </div>
  );
};

export default observer(LoginForm);
